// import React, { useState, useEffect } from "react";
// import { 
//   TextField, Button, MenuItem, Typography, Box, 
//   Table, TableBody, TableCell, TableContainer, 
//   TableHead, TableRow, Paper, IconButton,
//   Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
//   Checkbox, Tooltip
// } from "@mui/material";
// import { firestore } from "../firebase.config";
// import { doc, setDoc, collection, getDocs, deleteDoc, query, where } from "firebase/firestore";
// import { getAuth, onAuthStateChanged } from "firebase/auth";
// import PageNavBar from "../components/PageNavBar";
// import DeleteIcon from '@mui/icons-material/Delete';
// import EditIcon from '@mui/icons-material/Edit';
// import DoneIcon from '@mui/icons-material/Done';
// import { useUserContext } from "../context/UserContext";
// import TenantBanner from "../components/TenantBanner";

// const AssignTask = () => {
//   // State management for users and tasks
//   const [users, setUsers] = useState([]); // List of available users
//   const [selectedUser, setSelectedUser] = useState(""); // Currently selected user
//   const [taskDescription, setTaskDescription] = useState(""); // Task description input
//   const [startTime, setStartTime] = useState(""); // Task start time
//   const [completionTime, setCompletionTime] = useState(""); // Assigned completion time
//   const [adminEmail, setAdminEmail] = useState(""); // Current admin's email
//   const [tasks, setTasks] = useState([]); // List of all tasks
//   const [deleteDialogOpen, setDeleteDialogOpen] = useState(false); // Delete confirmation dialog state
//   const [taskToDelete, setTaskToDelete] = useState(null); // Task selected for deletion
//   const [isEditMode, setIsEditMode] = useState(false); // Bulk edit mode state
//   const [selectedTasks, setSelectedTasks] = useState([]); // Tasks selected for bulk operations
//   const [bulkDeleteDialogOpen, setBulkDeleteDialogOpen] = useState(false); // Bulk delete dialog state
//   const [taskError, setTaskError] = useState(""); // Error message state for task operations
//   const { userRole, tenantId, selectedTenantId } = useUserContext();

//   const tenantFilterID =
//     userRole === "SuperAdmin"
//       ? selectedTenantId || sessionStorage.getItem("selectedTenantId")
//       : tenantId || sessionStorage.getItem("selectedTenantId");

//   // Function to fetch all tasks from Firestore
//   const fetchTasks = async () => {
//     const tasksCollection = collection(firestore, "assignedTasks");
//     const taskSnapshot = await getDocs(tasksCollection);
//     const taskList = taskSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
//     setTasks(taskList);
//   };

//   // Initial setup effect - runs once on component mount
//   useEffect(() => {
//     // Set up authentication listener
//     const auth = getAuth();
//     onAuthStateChanged(auth, (user) => {
//       if (user) setAdminEmail(user.email);
//     });

//     // Fetch users from Firestore
//     const fetchUsers = async () => {
//       const tenantFilterID =
//          userRole === "SuperAdmin"
//         ? selectedTenantId || sessionStorage.getItem("selectedTenantId")
//         : tenantId || sessionStorage.getItem("selectedTenantId");

//     if (!tenantFilterID) {
//       console.warn("Missing tenantFilterID");
//       return;
//     }

//       const q = query(
//         collection(firestore, "Users"),
//         where("Is_Active", "==", true),
//         where("tenantId", "==", tenantFilterID)
//       );

//       const userSnapshot = await getDocs(q);
//       const userList = userSnapshot.docs.map(doc => {
//         const data = doc.data();
//         return {
//           id: doc.id,
//           userEmail: data.userEmail,
//         };
//       });
//       setUsers(userList);
//     };

//     fetchUsers();
//     fetchTasks();
//   }, [userRole, tenantId, selectedTenantId]);

//   // Effect to check and update task status every 5 seconds
//   useEffect(() => {
//     const checkForOngoingTasks = async () => {
//       const now = new Date();
//       const updatedTasks = tasks.map((task) => {
//         // Update task status to "Ongoing" if start time has passed
//         if (task.status === "Pending" && new Date(task.startTime) <= now) {
//           const taskDocRef = doc(firestore, "assignedTasks", task.id);
//           setDoc(taskDocRef, { ...task, status: "Ongoing" }, { merge: true });
//           return { ...task, status: "Ongoing" };
//         }
//         return task;
//       });
//       setTasks(updatedTasks);
//     };

//     const interval = setInterval(checkForOngoingTasks, 5000);
//     return () => clearInterval(interval);
//   }, [tasks]);

//   // Function to handle task assignment
//   const handleAssignTask = async () => {
//     // Validate required fields
//     if (!selectedUser || !taskDescription || !startTime || !completionTime) {
//       alert("Please fill all fields.");
//       return;
//     }

//     const auth = getAuth();
//     const currentUser = auth.currentUser;
//     if (!currentUser) {
//       alert("User not authenticated. Please log in.");
//       return;
//     }

//     // Prepare task data
//     const taskData = {
//       assignedBy: adminEmail,
//       assignedTo: selectedUser,
//       taskDescription,
//       startTime,
//       completionTime,  // Assigned End Time
//       status: "Pending",
//       tenantId: tenantFilterID,
//     };

//     const taskId = `${selectedUser}_${Date.now()}`;

//     try {
//       // Save task to Firestore
//       await setDoc(doc(firestore, "assignedTasks", taskId), taskData);
//       alert("Task assigned successfully!");

//       // Update local state
//       setTasks(prevTasks => [...prevTasks, { id: taskId, ...taskData }]);
//       // Reset form fields
//       setSelectedUser("");
//       setTaskDescription("");
//       setStartTime("");
//       setCompletionTime("");
//     } catch (error) {
//       console.error("Error assigning task:", error);
//       alert("Failed to assign task.");
//     }
//   };

//   // Function to handle task deletion with ongoing task check
//   const handleDeleteClick = (task) => {
//     // Prevent deletion of ongoing tasks
//     if (task.startTime && !task.endTime) {
//       setTaskError("Cannot delete an ongoing task. Please wait for it to complete.");
//       return;
//     }
//     setTaskToDelete(task);
//     setDeleteDialogOpen(true);
//   };

//   // Function to confirm task deletion
//   const handleDeleteConfirm = async () => {
//     if (!taskToDelete) return;

//     try {
//       // Delete task from Firestore
//       await deleteDoc(doc(firestore, "assignedTasks", taskToDelete.id));
      
//       // Update local state
//       setTasks(prevTasks => prevTasks.filter(task => task.id !== taskToDelete.id));
      
//       // Reset states
//       setDeleteDialogOpen(false);
//       setTaskToDelete(null);
      
//       alert("Task deleted successfully!");
//     } catch (error) {
//       console.error("Error deleting task:", error);
//       alert("Failed to delete task.");
//     }
//   };

//   // Function to cancel task deletion
//   const handleDeleteCancel = () => {
//     setDeleteDialogOpen(false);
//     setTaskToDelete(null);
//   };

//   // Function to toggle edit mode for bulk operations
//   const handleEditModeToggle = () => {
//     setIsEditMode(!isEditMode);
//     setSelectedTasks([]); // Clear selections when toggling edit mode
//   };

//   // Function to handle individual task selection
//   const handleTaskSelect = (taskId) => {
//     setSelectedTasks(prev => {
//       if (prev.includes(taskId)) {
//         return prev.filter(id => id !== taskId);
//       } else {
//         return [...prev, taskId];
//       }
//     });
//   };

//   // Function to handle select all tasks
//   const handleSelectAllTasks = (event) => {
//     if (event.target.checked) {
//       setSelectedTasks(tasks.map(task => task.id));
//     } else {
//       setSelectedTasks([]);
//     }
//   };

//   // Function to handle bulk delete initiation
//   const handleBulkDelete = () => {
//     if (selectedTasks.length === 0) return;
//     setBulkDeleteDialogOpen(true);
//   };

//   // Function to confirm bulk deletion
//   const handleBulkDeleteConfirm = async () => {
//     try {
//       // Delete all selected tasks from Firestore
//       await Promise.all(
//         selectedTasks.map(taskId => 
//           deleteDoc(doc(firestore, "assignedTasks", taskId))
//         )
//       );
      
//       // Update local state
//       setTasks(prevTasks => 
//         prevTasks.filter(task => !selectedTasks.includes(task.id))
//       );
      
//       // Reset states
//       setSelectedTasks([]);
//       setBulkDeleteDialogOpen(false);
//       setIsEditMode(false);
      
//       alert(`Successfully deleted ${selectedTasks.length} tasks!`);
//     } catch (error) {
//       console.error("Error deleting tasks:", error);
//       alert("Failed to delete some tasks. Please try again.");
//     }
//   };

//   // Function to format timestamps for display with seconds
//   const formatTimestamp = (timestamp) => {
//     if (!timestamp) return "Not Set";
//     try {
//       // Check if the timestamp is in ISO format
//       if (typeof timestamp === 'string' && timestamp.includes('T')) {
//         const date = new Date(timestamp);
//         return date.toLocaleTimeString('en-US', {
//           hour: '2-digit',
//           minute: '2-digit',
//           second: '2-digit', // Include seconds in the time display
//           hour12: true
//         });
//       }
//       // If it's already in HH:MM:SS AM/PM format, return as is
//       return timestamp;
//     } catch (error) {
//       console.error('Error formatting timestamp:', error);
//       return "Invalid Date";
//     }
//   };

//   return (
//     <Box>
//       <PageNavBar title="Assign Task" backTo="/dashboard" />
//       <TenantBanner />
//       <Box sx={{ p: 3, mt: 2, maxWidth: 500, mx: "auto" }}>
//         <Typography variant="h5" sx={{ mb: 3, textAlign: "center" }}>Assign Task</Typography>
//         <Box component="form" noValidate autoComplete="off">
//           <TextField
//             select
//             label="Select User"
//             value={selectedUser}
//             onChange={(e) => setSelectedUser(e.target.value)}
//             fullWidth
//             sx={{ mb: 2 }}
//           >
//             {users.map((user) => (
//               <MenuItem key={user.id} value={user.userEmail}>
//                 {user.userEmail}
//               </MenuItem>
//             ))}
//           </TextField>
//           <TextField
//             label="Task Description"
//             value={taskDescription}
//             onChange={(e) => setTaskDescription(e.target.value)}
//             fullWidth
//             multiline
//             rows={3}
//             sx={{ mb: 2 }}
//           />
//           <TextField
//             type="datetime-local"
//             label="Start Time"
//             value={startTime}
//             onChange={(e) => setStartTime(e.target.value)}
//             fullWidth
//             sx={{ mb: 2 }}
//             InputLabelProps={{ shrink: true }}
//           />
//           <TextField
//             type="datetime-local"
//             label="Assigned End Time"
//             value={completionTime}
//             onChange={(e) => setCompletionTime(e.target.value)}
//             fullWidth
//             sx={{ mb: 2 }}
//             InputLabelProps={{ shrink: true }}
//           />
//           <Button
//             variant="contained"
//             color="primary"
//             onClick={handleAssignTask}
//             fullWidth
//             sx={{ mt: 2 }}
//           >
//             Assign Task
//           </Button>
//         </Box>
//       </Box>

//       {/* Display Assigned Tasks */}
//       <Box sx={{ p: 3, mt: 4, maxWidth: "80%", mx: "auto" }}>
//         <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
//           <Typography variant="h6">Assigned Tasks</Typography>
//           <Box>
//             {isEditMode && selectedTasks.length > 0 && (
//               <Button
//                 variant="contained"
//                 color="error"
//                 onClick={handleBulkDelete}
//                 sx={{ mr: 2 }}
//               >
//                 Delete Selected ({selectedTasks.length})
//               </Button>
//             )}
//             <Tooltip title={isEditMode ? "Exit Edit Mode" : "Enter Edit Mode"}>
//               <IconButton onClick={handleEditModeToggle} color={isEditMode ? "primary" : "default"}>
//                 {isEditMode ? <DoneIcon /> : <EditIcon />}
//               </IconButton>
//             </Tooltip>
//           </Box>
//         </Box>
//         <TableContainer component={Paper}>
//           <Table>
//             <TableHead>
//               <TableRow>
//                 {isEditMode && (
//                   <TableCell padding="checkbox">
//                     <Checkbox
//                       onChange={handleSelectAllTasks}
//                       checked={selectedTasks.length === tasks.length && tasks.length > 0}
//                       indeterminate={selectedTasks.length > 0 && selectedTasks.length < tasks.length}
//                     />
//                   </TableCell>
//                 )}
//                 <TableCell><b>Assigned To</b></TableCell>
//                 <TableCell><b>Assigned By</b></TableCell>
//                 <TableCell><b>Task</b></TableCell>
//                 <TableCell><b>Start Time</b></TableCell>
//                 <TableCell><b>Assigned End Time</b></TableCell>
//                 <TableCell><b>Actual End Time</b></TableCell>
//                 <TableCell><b>Status</b></TableCell>
//                 {!isEditMode && <TableCell><b>Actions</b></TableCell>}
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {tasks  
//                 .filter(task => task.tenantId === tenantFilterID)
//                 .map((task) => (
//                   <TableRow key={task.id}>
//                     {isEditMode && (
//                       <TableCell padding="checkbox">
//                         <Checkbox
//                           checked={selectedTasks.includes(task.id)}
//                           onChange={() => handleTaskSelect(task.id)}
//                         />
//                       </TableCell>
//                     )}
//                     <TableCell>{task.assignedTo}</TableCell>
//                     <TableCell>{task.assignedBy || "N/A"}</TableCell>
//                     <TableCell>{task.taskDescription}</TableCell>
//                     <TableCell>{formatTimestamp(task.startTime)}</TableCell>
//                     <TableCell>{formatTimestamp(task.completionTime)}</TableCell>
//                     <TableCell>
//                       {task.endTime ? formatTimestamp(task.endTime) : "Not Completed"}
//                     </TableCell>
//                     <TableCell>{task.status}</TableCell>
//                     {!isEditMode && (
//                       <TableCell>
//                         <IconButton 
//                           color="error"
//                           onClick={() => handleDeleteClick(task)}
//                           disabled={task.status === "Completed" || (task.startTime && !task.endTime)}
//                         >
//                           <DeleteIcon />
//                         </IconButton>
//                       </TableCell>
//                     )}
//                   </TableRow>
//                 ))}
//             </TableBody>
//           </Table>
//         </TableContainer>
//       </Box>

//       {/* Delete Confirmation Dialog */}
//       <Dialog
//         open={deleteDialogOpen}
//         onClose={handleDeleteCancel}
//       >
//         <DialogTitle>Delete Task</DialogTitle>
//         <DialogContent>
//           <DialogContentText>
//             {taskError}
//             {taskToDelete && (
//               <Box sx={{ mt: 2 }}>
//                 <Typography><b>Task:</b> {taskToDelete.taskDescription}</Typography>
//                 <Typography><b>Assigned To:</b> {taskToDelete.assignedTo}</Typography>
//               </Box>
//             )}
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleDeleteCancel}>Cancel</Button>
//           <Button onClick={handleDeleteConfirm} color="error" variant="contained">
//             Delete
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Bulk Delete Confirmation Dialog */}
//       <Dialog
//         open={bulkDeleteDialogOpen}
//         onClose={() => setBulkDeleteDialogOpen(false)}
//       >
//         <DialogTitle>Delete Multiple Tasks</DialogTitle>
//         <DialogContent>
//           <DialogContentText>
//             Are you sure you want to delete {selectedTasks.length} selected tasks? This action cannot be undone.
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setBulkDeleteDialogOpen(false)}>Cancel</Button>
//           <Button onClick={handleBulkDeleteConfirm} color="error" variant="contained">
//             Delete All Selected
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default AssignTask;


import React, { useState, useEffect } from "react";
import { 
  TextField, Button, MenuItem, Typography, Box, 
  Table, TableBody, TableCell, TableContainer, 
  TableHead, TableRow, Paper, IconButton,
  Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
  Checkbox, Tooltip
} from "@mui/material";
import { firestore } from "../firebase.config";
import { doc, setDoc, collection, getDocs, deleteDoc, query, where } from "firebase/firestore";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import PageNavBar from "../components/PageNavBar";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import DoneIcon from '@mui/icons-material/Done';
import { useUserContext } from "../context/UserContext";
import TenantBanner from "../components/TenantBanner";

const AssignTask = () => {
  // State management for users and tasks
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [taskDescription, setTaskDescription] = useState("");
  const [startTime, setStartTime] = useState("");
  const [completionTime, setCompletionTime] = useState("");
  const [adminEmail, setAdminEmail] = useState("");
  const [tasks, setTasks] = useState([]);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [taskToDelete, setTaskToDelete] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedTasks, setSelectedTasks] = useState([]);
  const [bulkDeleteDialogOpen, setBulkDeleteDialogOpen] = useState(false);
  const [taskError, setTaskError] = useState("");
  const [currentTime, setCurrentTime] = useState(new Date()); // NEW: Added for client-side status calculation
  const { userRole, tenantId, selectedTenantId } = useUserContext();

  const tenantFilterID =
    userRole === "SuperAdmin"
      ? selectedTenantId || sessionStorage.getItem("selectedTenantId")
      : tenantId || sessionStorage.getItem("selectedTenantId");

  // NEW: Function to calculate task status client-side
  const calculateTaskStatus = (task) => {
    const now = currentTime;
    const start = new Date(task.startTime);
    const completion = new Date(task.completionTime);
    
    if (task.endTime) return "Completed";
    if (now > completion) return "Overdue";
    if (now > start) return "Ongoing";
    return "Pending";
  };

  // Function to fetch all tasks from Firestore
  const fetchTasks = async () => {
    const tasksCollection = collection(firestore, "assignedTasks");
    const taskSnapshot = await getDocs(tasksCollection);
    const taskList = taskSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setTasks(taskList);
  };

  // Initial setup effect - runs once on component mount
  useEffect(() => {
    // Set up authentication listener
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (user) setAdminEmail(user.email);
    });

    // Fetch users from Firestore
    const fetchUsers = async () => {
      if (!tenantFilterID) {
        console.warn("Missing tenantFilterID");
        return;
      }

      const q = query(
        collection(firestore, "Users"),
        where("Is_Active", "==", true),
        where("tenantId", "==", tenantFilterID)
      );

      const userSnapshot = await getDocs(q);
      const userList = userSnapshot.docs.map(doc => {
        const data = doc.data();
        return {
          id: doc.id,
          userEmail: data.userEmail,
        };
      });
      setUsers(userList);
    };

    fetchUsers();
    fetchTasks();
    
    // NEW: Set up time refresh every minute instead of Firestore writes
    const timeInterval = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000); // Update every minute
    
    return () => clearInterval(timeInterval);
  }, [userRole, tenantId, selectedTenantId]);

  // OLD: Effect that caused excessive Firestore writes (commented out)
  /*
  useEffect(() => {
    const checkForOngoingTasks = async () => {
      const now = new Date();
      const updatedTasks = tasks.map((task) => {
        // Update task status to "Ongoing" if start time has passed
        if (task.status === "Pending" && new Date(task.startTime) <= now) {
          const taskDocRef = doc(firestore, "assignedTasks", task.id);
          setDoc(taskDocRef, { ...task, status: "Ongoing" }, { merge: true });
          return { ...task, status: "Ongoing" };
        }
        return task;
      });
      setTasks(updatedTasks);
    };

    const interval = setInterval(checkForOngoingTasks, 5000);
    return () => clearInterval(interval);
  }, [tasks]);
  */

  // Function to handle task assignment
  const handleAssignTask = async () => {
    // Validate required fields
    if (!selectedUser || !taskDescription || !startTime || !completionTime) {
      alert("Please fill all fields.");
      return;
    }

    const userQuery = query(
      collection(firestore, "Users"),
      where("userEmail", "==", selectedUser),
      where("Is_Active", "==", true),
      where("tenantId", "==", tenantFilterID)
    );

    const userSnap = await getDocs(userQuery);

    if (userSnap.empty) {
      setTaskError("Cannot assign task. The selected user is inactive or does not exist.");
      return;
    }

    const auth = getAuth();
    const currentUser = auth.currentUser;
    if (!currentUser) {
      alert("User not authenticated. Please log in.");
      return;
    }

    // Prepare task data
    const taskData = {
      assignedBy: adminEmail,
      assignedTo: selectedUser,
      taskDescription,
      startTime,
      completionTime,  // Assigned End Time
      status: "Pending",
      tenantId: tenantFilterID,
    };

    const taskId = `${selectedUser}_${Date.now()}`;

    try {
      // Save task to Firestore (FIRST WRITE)
      await setDoc(doc(firestore, "assignedTasks", taskId), taskData);
      alert("Task assigned successfully!");

      // Update local state
      setTasks(prevTasks => [...prevTasks, { id: taskId, ...taskData }]);
      // Reset form fields
      setSelectedUser("");
      setTaskDescription("");
      setStartTime("");
      setCompletionTime("");
    } catch (error) {
      console.error("Error assigning task:", error);
      alert("Failed to assign task.");
    }
  };

  // Function to handle task deletion with ongoing task check
  const handleDeleteClick = (task) => {
    // NEW: Use client-side calculated status instead of Firestore status
    const status = calculateTaskStatus(task);
    if (status === "Ongoing") {
      setTaskError("Cannot delete an ongoing task. Please wait for it to complete.");
      return;
    }
    setTaskToDelete(task);
    setDeleteDialogOpen(true);
  };

  // Function to confirm task deletion (SECOND WRITE)
  const handleDeleteConfirm = async () => {
    if (!taskToDelete) return;

    try {
      // Delete task from Firestore
      await deleteDoc(doc(firestore, "assignedTasks", taskToDelete.id));
      
      // Update local state
      setTasks(prevTasks => prevTasks.filter(task => task.id !== taskToDelete.id));
      
      // Reset states
      setDeleteDialogOpen(false);
      setTaskToDelete(null);
      
      alert("Task deleted successfully!");
    } catch (error) {
      console.error("Error deleting task:", error);
      alert("Failed to delete task.");
    }
  };

  // Function to cancel task deletion
  const handleDeleteCancel = () => {
    setDeleteDialogOpen(false);
    setTaskToDelete(null);
  };

  // Function to toggle edit mode for bulk operations
  const handleEditModeToggle = () => {
    setIsEditMode(!isEditMode);
    setSelectedTasks([]); // Clear selections when toggling edit mode
  };

  // Function to handle individual task selection
  const handleTaskSelect = (taskId) => {
    setSelectedTasks(prev => {
      if (prev.includes(taskId)) {
        return prev.filter(id => id !== taskId);
      } else {
        return [...prev, taskId];
      }
    });
  };

  // Function to handle select all tasks
  const handleSelectAllTasks = (event) => {
    if (event.target.checked) {
      setSelectedTasks(tasks.map(task => task.id));
    } else {
      setSelectedTasks([]);
    }
  };

  // Function to handle bulk delete initiation
  const handleBulkDelete = () => {
    if (selectedTasks.length === 0) return;
    setBulkDeleteDialogOpen(true);
  };

  // Function to confirm bulk deletion
  const handleBulkDeleteConfirm = async () => {
    try {
      // Delete all selected tasks from Firestore
      await Promise.all(
        selectedTasks.map(taskId => 
          deleteDoc(doc(firestore, "assignedTasks", taskId))
        )
      );
      
      // Update local state
      setTasks(prevTasks => 
        prevTasks.filter(task => !selectedTasks.includes(task.id))
      );
      
      // Reset states
      setSelectedTasks([]);
      setBulkDeleteDialogOpen(false);
      setIsEditMode(false);
      
      alert(`Successfully deleted ${selectedTasks.length} tasks!`);
    } catch (error) {
      console.error("Error deleting tasks:", error);
      alert("Failed to delete some tasks. Please try again.");
    }
  };

  // Function to format timestamps for display with seconds
  const formatTimestamp = (timestamp) => {
    if (!timestamp) return "Not Set";
    try {
      // Check if the timestamp is in ISO format
      if (typeof timestamp === 'string' && timestamp.includes('T')) {
        const date = new Date(timestamp);
        return date.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit', // Include seconds in the time display
          hour12: true
        });
      }
      // If it's already in HH:MM:SS AM/PM format, return as is
      return timestamp;
    } catch (error) {
      console.error('Error formatting timestamp:', error);
      return "Invalid Date";
    }
  };

  return (
    <Box sx={{ 
      minHeight: "100vh",
      background: "linear-gradient(135deg, #3b82f6 0%, #7c3aed 50%, rgb(231, 58, 237) 100%)",
      display: "flex",
      flexDirection: "column",
      position: "relative",
      overflow: "hidden",
    }}>
      <PageNavBar title="Assign Task" backTo="/dashboard" />
      <TenantBanner />
      
      {/* White Card Box: Task Assignment Form */}
      <Box
        sx={{
          backgroundColor: "white",
          borderRadius: 0,
          p: { xs: 3, md: 4 },
          boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
          width: {
            xs: "calc(100% - 40px)",
            sm: "70%",
            md: "500px",
          },
          maxWidth: { xs: "calc(100vw - 40px)", md: 600 },
          minHeight: { xs: 400, md: 450 },
          mx: "auto",
          mt: { xs: 4, md: 6 },
          alignSelf: "center",
        }}
      >
        <Typography variant="h5" sx={{ mb: 3, textAlign: "center", color: "black" }}>Assign Task</Typography>
        <Box component="form" noValidate autoComplete="off">
          <TextField
            select
            label="Select User"
            value={selectedUser}
            onChange={(e) => setSelectedUser(e.target.value)}
            fullWidth
            sx={{ mb: 2 }}
          >
            {users.map((user) => (
              <MenuItem key={user.id} value={user.userEmail}>
                {user.userEmail}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            label="Task Description"
            value={taskDescription}
            onChange={(e) => setTaskDescription(e.target.value)}
            fullWidth
            multiline
            rows={3}
            sx={{ mb: 2 }}
          />
          <TextField
            type="datetime-local"
            label="Start Time"
            value={startTime}
            onChange={(e) => setStartTime(e.target.value)}
            fullWidth
            sx={{ mb: 2 }}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            type="datetime-local"
            label="Assigned End Time"
            value={completionTime}
            onChange={(e) => setCompletionTime(e.target.value)}
            fullWidth
            sx={{ mb: 2 }}
            InputLabelProps={{ shrink: true }}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={handleAssignTask}
            fullWidth
            sx={{ mt: 2 }}
          >
            Assign Task
          </Button>
        </Box>
        </Box>

      {/* Display Assigned Tasks */}
      <Box sx={{ p: { xs: 2, sm: 3 }, mt: 4, width: { xs: "calc(100% - 32px)", sm: "90%", md: "80%" }, mx: "auto" }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h6" sx={{ color: "white" }}>Assigned Tasks</Typography>
          <Box>
            {isEditMode && selectedTasks.length > 0 && (
              <Button
                variant="contained"
                color="error"
                onClick={handleBulkDelete}
                sx={{ mr: 2 }}
              >
                Delete Selected ({selectedTasks.length})
              </Button>
            )}
                         <Tooltip title={isEditMode ? "Exit Edit Mode" : "Enter Edit Mode"}>
               <IconButton 
                 onClick={handleEditModeToggle} 
                 sx={{ 
                   color: "white",
                   "&:hover": {
                     backgroundColor: "rgba(255, 255, 255, 0.1)"
                   }
                 }}
               >
                 {isEditMode ? <DoneIcon /> : <EditIcon />}
               </IconButton>
             </Tooltip>
          </Box>
        </Box>
        
        
        
        <TableContainer 
          component={Paper} 
          sx={{ 
            maxHeight: { xs: 400, sm: 500, md: 600 },
            overflow: "auto",
            "& .MuiTable-root": {
              minWidth: { xs: 800, sm: 900, md: 1000 }
            },
            "& .MuiTableHead-root": {
              position: "sticky",
              top: 0,
              backgroundColor: "white",
              zIndex: 1,
              "& .MuiTableCell-root": {
                backgroundColor: "white",
                fontWeight: "bold"
              }
            },
            "& .MuiTableBody-root": {
              "& .MuiTableRow-root:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.04)"
              }
            },
            border: "1px solid #e0e0e0",
            borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
          }}
        >
          <Table sx={{
            "& .MuiTableCell-root": {
              padding: { xs: "8px 4px", sm: "12px 8px", md: "16px" },
              fontSize: { xs: "0.75rem", sm: "0.875rem", md: "1rem" },
              whiteSpace: "nowrap",
              borderBottom: "1px solid #e0e0e0"
            },
            "& .MuiTableHead-root .MuiTableCell-root": {
              backgroundColor: "#f5f5f5",
              fontWeight: "bold",
              color: "#333"
            }
          }}>
            <TableHead>
              <TableRow>
                {isEditMode && (
                  <TableCell padding="checkbox">
                    <Checkbox
                      onChange={handleSelectAllTasks}
                      checked={selectedTasks.length === tasks.length && tasks.length > 0}
                      indeterminate={selectedTasks.length > 0 && selectedTasks.length < tasks.length}
                    />
                  </TableCell>
                )}
                <TableCell><b>Assigned To</b></TableCell>
                <TableCell><b>Assigned By</b></TableCell>
                <TableCell><b>Task</b></TableCell>
                <TableCell><b>Start Time</b></TableCell>
                <TableCell><b>Assigned End Time</b></TableCell>
                <TableCell><b>Actual End Time</b></TableCell>
                <TableCell><b>Status</b></TableCell>
                {!isEditMode && <TableCell><b>Actions</b></TableCell>}
              </TableRow>
            </TableHead>
            <TableBody>
              {tasks  
                .filter(task => task.tenantId === tenantFilterID)
                .map((task) => {
                  // NEW: Calculate status client-side
                  const status = calculateTaskStatus(task);
                  return (
                    <TableRow key={task.id}>
                      {isEditMode && (
                        <TableCell padding="checkbox">
                          <Checkbox
                            checked={selectedTasks.includes(task.id)}
                            onChange={() => handleTaskSelect(task.id)}
                          />
                        </TableCell>
                      )}
                      <TableCell>{task.assignedTo}</TableCell>
                      <TableCell>{task.assignedBy || "N/A"}</TableCell>
                      <TableCell>{task.taskDescription}</TableCell>
                      <TableCell>{formatTimestamp(task.startTime)}</TableCell>
                      <TableCell>{formatTimestamp(task.completionTime)}</TableCell>
                      <TableCell>
                        {task.endTime ? formatTimestamp(task.endTime) : "Not Completed"}
                      </TableCell>
                      {/* NEW: Use client-side calculated status */}
                      <TableCell sx={{
                      color:
                      status === "Overdue"
                      ? "error.main"
                      : status === "Completed"
                      ? "success.main"
                      : "text.primary",
                      fontWeight: 500,
                      }}>{status}</TableCell>
                      {!isEditMode && (
                        <TableCell>
                          <IconButton 
                            color="error"
                            onClick={() => handleDeleteClick(task)}
                            // NEW: Use client-side calculated status for disabling
                            disabled={status === "Ongoing"}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </TableCell>
                      )}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={deleteDialogOpen}
        onClose={handleDeleteCancel}
      >
        <DialogTitle>Delete Task</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {taskError}
            {taskToDelete && (
              <Box sx={{ mt: 2 }}>
                <Typography><b>Task:</b> {taskToDelete.taskDescription}</Typography>
                <Typography><b>Assigned To:</b> {taskToDelete.assignedTo}</Typography>
              </Box>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel}>Cancel</Button>
          <Button onClick={handleDeleteConfirm} color="error" variant="contained">
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Bulk Delete Confirmation Dialog */}
      <Dialog
        open={bulkDeleteDialogOpen}
        onClose={() => setBulkDeleteDialogOpen(false)}
      >
        <DialogTitle>Delete Multiple Tasks</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete {selectedTasks.length} selected tasks? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setBulkDeleteDialogOpen(false)}>Cancel</Button>
          <Button onClick={handleBulkDeleteConfirm} color="error" variant="contained">
            Delete All Selected
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AssignTask;
